

define(function (require, exports, module) {

    /**
     * @file 继承和扩展
     * @author 子虔
     * @date    2014-08-15 11:24:20
     * @param  {Object} protoProps  子类的prototype
     * @param  {[type]} staticProps 子类的静态方法或属性
     * @return {Class}
     */
    var inherits = require('./inherits');

    module.exports = function (protoProps, staticProps) {
        var parent = this,
            child,
            destroy;

        // The constructor function for the new subclass is either defined by you
        // (the "constructor" property in your `extend` definition), or defaulted
        // by us to simply call the parent's constructor.
        if (protoProps && protoProps.hasOwnProperty('constructor')) {
            child = protoProps.constructor;
        } else {
            child = function child() {
                return parent.apply(this, arguments);
            };
        }

        // inherits
        inherits(child, parent, protoProps, staticProps);

        // 销毁自动继承
        if (protoProps.hasOwnProperty('destroy') && (destroy = protoProps.destroy)) {
            protoProps.destroy = function () {
                try {
                    destroy.apply(this, arguments);
                } catch (e) {}

                try {
                    parent.prototype.destroy.apply(this, arguments);
                } catch (e) {}
            };
        }

        return child;
    };
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/c-base/dist/extend.js
// module id = 42
// module chunks = 0